import {MapFeature} from '../types';

// Compare user-editable data only. Sync versions and timestamps do not represent edits.
const fields = ['label','notes','geometry_type','coordinates_geojson','point_kind','is_inactive','feature_type','entity_type','entity_id','color','fill_color','fill_opacity','stroke_weight'] as const;
function canonical(value:unknown):unknown {
  if(Array.isArray(value))return value.map(canonical);
  if(value&&typeof value==='object')return Object.fromEntries(Object.entries(value).sort(([a],[b])=>a.localeCompare(b)).map(([key,item])=>[key,canonical(item)]));
  return value;
}
export function placeDraftSignature(place:Partial<MapFeature>|null|undefined) {
  if(!place)return '';
  return JSON.stringify(fields.map(key=>{
    const value=place[key];
    if(key==='is_inactive')return !!value;
    if(key==='coordinates_geojson'){try{return canonical(JSON.parse(value as string));}catch{return value||'';}}
    return value??'';
  }));
}
export function hasPlaceDraftChanges(draft:Partial<MapFeature>|null,baseline:Partial<MapFeature>|null) {
  return !!draft&&placeDraftSignature(draft)!==placeDraftSignature(baseline);
}
